<template>
  <div id="app" class="my_app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue